import { IntervalModel, PriceModel } from "$models";
import { formatNumber } from "../utils/misc.ts";
import type { MyPagesSpot, SpotData } from "$apis/parkito2/index.ts";

export default class MyPagesSpotModel implements MyPagesSpot {
  constructor(private _data: MyPagesSpot) {}

  toSpotData(): SpotData {
    return {
      accessCodeSeriesId: this.accessCodeRef?.id,
      agreementPeriod: this.agreementPeriod,
      blockedFrom: this.blockedFrom,
      blockedUntil: this.blockedUntil,
      kind: this.kind,
      name: this.name,
      numericName: this.numericName,
    };
  }

  getFormattedPriceWithVat(): string | undefined {
    return this._data.derivedPrice?.normal
      ? formatNumber(
        this._data.derivedPrice.normal.sub +
          this._data.derivedPrice.normal.vat,
      )
      : undefined;
  }

  getFormattedPriceExVat(): string | undefined {
    return this._data.derivedPrice?.normal
      ? formatNumber(
        this._data.derivedPrice.normal.sub,
      )
      : undefined;
  }

  isResidentalVatFree(): boolean {
    return !!this._data.derivedPrice?.residental?.sub &&
      this._data.derivedPrice?.residental?.sub <
        this._data.derivedPrice?.normal?.sub;
  }

  get accessCodeRef() {
    return this._data.accessCodeRef;
  }
  get agreementPeriod(): IntervalModel | undefined {
    return this._data.agreementPeriod
      ? new IntervalModel(this._data.agreementPeriod)
      : undefined;
  }
  get area() {
    return this._data.area;
  }
  get blockedFrom() {
    return this._data.blockedFrom;
  }
  get blockedUntil() {
    return this._data.blockedUntil;
  }
  get derivedPrice() {
    if (!this._data.derivedPrice) {
      return undefined;
    }
    return {
      normal: new PriceModel(this._data.derivedPrice.normal),
      residental: new PriceModel(this._data.derivedPrice.residental),
    };
  }
  get id() {
    return this._data.id;
  }
  get kind() {
    return this._data.kind;
  }
  get name() {
    return this._data.name;
  }
  get numericName(): number {
    return this._data.numericName;
  }
  get siteId() {
    return this._data.siteId;
  }
  get tagIds() {
    return this._data.tagIds;
  }
}
